module.exports = __webpack_public_path__ + "img/daily_3.71f844b2.png";